import { useContext } from 'react';
import { SetupContext } from '../Contexts/SetupContext';
import { MdHelpOutline } from 'react-icons/md';
import { IconButton, Tooltip } from '@material-ui/core';

const handleHelpClick = (e, url) => {
  e.stopPropagation()
  window.open(url, "_blank")
}

const HelpIconButton = ({ objectname = "", styleObject = {} }) => {
  const { setup } = useContext(SetupContext)
  const { helpContexts } = setup.setupLists || []
  //find objectname name, name lowercase so capitalizations doesnt matter
  const url = helpContexts?.find(helpLink => helpLink.name?.toLowerCase() === objectname?.toLowerCase())?.helpUrl

  return (
    url
      ?
      <Tooltip
        title="Help"
      >
        <IconButton
          style={{ ...{ padding: "0px" }, ...styleObject }}
          onClick={
            (e) => handleHelpClick(e, url)
          }
        >
          <MdHelpOutline data-testid="help-icon"/>
        </IconButton>
      </Tooltip>
      : <div />
  );

}
export default HelpIconButton;